(function(){
  if(window.__bbpCountdown){window.__bbpCountdown();return;}
  function pad(n){return String(n).padStart(2,'0');}
  function tick(){
    document.querySelectorAll('[data-bbp-end]').forEach(function(el){
      var end=Date.parse(el.getAttribute('data-bbp-end'));
      if(isNaN(end))return;
      var d=Math.max(0,end-Date.now());
      el.classList.toggle('is-closed',d<=0);
      var v={d:Math.floor(d/864e5),h:Math.floor(d/36e5)%24,m:Math.floor(d/6e4)%60};
      el.querySelectorAll('[data-u]').forEach(function(u){u.textContent=pad(v[u.getAttribute('data-u')]);});
    });
  }
  window.__bbpCountdown=tick;
  tick();setInterval(tick,15000);
  document.addEventListener('shopify:section:load',tick);
})();